<template>
<html lang="en">
<body>
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title><h1>My Resume!!</h1></title>
  

</head>

<link href='https://fonts.googleapis.com/css?family=Lato:400,300,700' rel='stylesheet' type='text/css'>
<div class="container">
<!--SECTION INFO-->

  <div class="header">
    <div style="float: right;" >
      <div class="contact-info" >
      <!--<router-link class="button1" to='/myfrenchresume'>French</router-link><span class="separator"></span>--><router-link class="button1" to='/myenglishresume'>Resume</router-link>
      </div>
    </div>
    <div> &nbsp; </div>
    <div> &nbsp; </div>
    <div class="full-name">
      <span class="first-name">{{firstName}}</span>
      <span class="last-name">{{lastName}}</span>
    </div>
    
    <div class="contact-info">
      <span class="email">Email: </span>
      <span class="email-val">{{email}}</span>
      <span class="separator"></span>
      <span class="phone">Phone: </span>
      <span class="phone-val">{{phone}}</span>
    </div>
    <div class="about">
      <span class="position">Freelance Back-End Developer</span>
      <span class="desc">
        {{description}}
      </span>
    </div>
  </div>
<!--END OF SECTION INFO-->
<hr>

    <section id="contact" class="section wow fadeInUp">

      <div class="container " data-aos="fade-right" >
<div id="errormessage" v-if="message=='message is invalid'==true"><h2>{{txt}}</h2></div>
<div id="sendmessage"   v-else-if="message=='message is valid'"><h2>{{validInputResponse}}</h2></div>
       <!---->
        <div class="form" v-show="inValidInputResponse = !validInputResponse">
          
          <form  class="contactForm" @submit.prevent="submitMessage">
           <!--<div class="contactForm">
          <label for="name">Your Name:</label>
          <input type="text" name="name" v-model.trim="userInput" />
        </div>
           <div></div>-->
            <div class="form-group">
              <textarea class="form-control" name="message" rows="5" data-rule="required" placeholder="Message here........." type="text" v-model="messageInput"></textarea>
              <div class="validation"></div>
            </div>
            <div class="text-center"><button type="submit" v-on:click="validateMessage">Send Message</button></div>
          </form>
        </div>

      </div>
    </section><!-- #contact -->  
</div>
</body>
</html>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
const firebaseConfig = {
databaseURL: "https://email-sender-7a0b6-default-rtdb.europe-west1.firebasedatabase.app/",
};
firebase.initializeApp(firebaseConfig);
//import axios from 'axios'
 export default {
  //https://console.firebase.google.com/u/0/project/stone-fletcher-resume/hosting/sites
    data(){
     return{
    firstName:'Stone',
    lastName:'Fletcher',
    email:'xxpressweb@gmail.com',
    phone:'+33772290659',
    description:`
    Accomplished and very experienced Nodejs developer with a complete mastery of
    lots of Nodejs modules. Able to work independently with little or no
    supervision as well as within a team as a full member.`,
    Info:`Self-taught developer in (Javascript, Vue.js, Node.js, C++, Python).`,
    userInput:'',
    messageInput:'',
    message:'pending',
    inValidInputResponse: '',
    validInputResponse:'',
    txt:''
  };
},
methods:{
    submitMessage(message,userId){
  let resumeLang='Message from English Resume.';
  let date = new Date();
  let hour = date.getHours();
  let minutes = date.getMinutes();
    let year = date.getFullYear();
  let dayDate= date.getDate();
  let d = date.getDay();
  let m = date.getMonth();
  const day   = ["Sunday","Monday", "Tuesday", "Wednesday", "Thursday", "Friday","saturday"];
  const month = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
 message=this.messageInput;
date = new Date().toISOString().replaceAll('-','').replaceAll(':','').replaceAll('.','');
userId=date;
 const database = firebase.database();
if(this.messageInput!=''){
database.ref('userMessages/'+ userId).set({
resumeLng:resumeLang,
date:day[d]+' '+month[m]+' '+dayDate+' '+year,
hour:hour+':'+minutes,
message: message
  });


/*
axios.post('https://email-sender-7a0b6-default-rtdb.europe-west1.firebasedatabase.app/email.json?key=AIzaSyDWtoOVRgEB2XAVx0BK9rKZgK7g4WXu2RU', {
resumeLng:resumeLang,
date:day[d]+' '+month[m]+' '+dayDate+' '+year,
hour:hour+':'+minutes,
message: this.messageInput
})
console.log(this.messageInput);// eslint-disable-line no-console
*/


}else{console.log('Mesage is empty...');// eslint-disable-line no-console
}
 },
validateMessage(){
if(this.messageInput===''){
this.message='message is invalid';
this.txt='Your message is empty!';
console.log(this.inValidInputResponse);// eslint-disable-line no-console
setTimeout(() => {
this.txt='';
},"5500")
console.log(this.message);// eslint-disable-line no-console
}else{
this.message='message is valid';
this.validInputResponse='Your message has been sent. Thank you!';
console.log(this.message);// eslint-disable-line no-console
}
},
}
}
</script>
